import axios from 'axios'
import { Component, FunctionalComponent } from 'preact'
import { Topic } from '../../control-components/topic-moderation/interfaces'
import InputGroup from '../../control-components/ui-components/InputGroup'
import ButtonControl from '../button-control'
import { Modal, ModalBody, ModalHeader } from '../modal'
import UserAvatar from '../User/UserAvatar'
import { capitalize } from '../utils/string'

/** TODO
 * Provide with correct typings.
 * "unknown" type requires a lot of checks, so it's off now
 */

type UnknownTopic = any

interface Props {
  isOpen: boolean
  onAdd: (topic: Topic) => void
  onClose: () => void
}

interface State {
  topic: UnknownTopic | null
  error: string | null
}

class AddTopicCardModal extends Component<Props, State> {
  urlInputRef: HTMLInputElement | null = null

  constructor(props: Props) {
    super(props)
    this.state = {
      topic: null,
      error: null
    }
  }

  componentDidMount = () => this.urlInputRef?.focus()

  onUrlInput = async (event: ChangeEvent<HTMLInputElement>) => {
    const topicUrl = event.target.value

    try {
      const response = await axios.get(`/topic/checkurl?checkurl=${topicUrl}`)

      const { topictitle, content, featuredimage, contenttype, author, url } = response.data

      this.setState({
        topic: {
          title: topictitle,
          content,
          featuredImage: featuredimage,
          contentType: contenttype,
          author,
          url
        },
        error: null
      })
    } catch (e) {
      this.setState({ topic: null, error: "Sorry, there's no topic matching that URL" })
    }
  }

  onAdd = () => {
    const { topic } = this.state
    this.props.onAdd(topic)
  }

  render({ isOpen, onClose }: Props, { topic, error }: State) {
    return (
      <Modal isOpen={isOpen} size='medium'>
        <ModalHeader title='Topic card' onClose={() => onClose()} />
        <ModalBody>
          <div className='add-topic-card-modal'>
            <InputGroup
              ref={(ref: any) => {
                this.urlInputRef = ref?.base.querySelector('input') ?? null
              }}
              newStyle
              placeholder='Embed a community topic by pasting topic URL'
              onKeyUp={this.onUrlInput}
            />
            {error && <div className='no-results'>{error}</div>}
            {topic && <TopicResult topic={topic} onAdd={this.onAdd} />}
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

interface TopicResultProps {
  topic: UnknownTopic
  onAdd: () => void
}

const TopicResult: FunctionalComponent<TopicResultProps> = ({ topic, onAdd }) => {
  const {
    title,
    contentType,
    author: { id, username, avatar }
  } = topic

  return (
    <div className='topic-result'>
      <div>
        <div className='title'>{title}</div>
        <div className='meta'>
          {capitalize(contentType)} by
          <UserAvatar
            disableLink
            style={{ width: '16px', height: '16px' }}
            user={{
              id: id,
              name: username,
              avatar
            }}
          />
          <span>{username}</span>
        </div>
      </div>
      <ButtonControl title='Add' newStyle onClick={() => onAdd()} />
    </div>
  )
}

export default AddTopicCardModal
